@use '../../styles/surface.scss' as surface;

.skeleton {
  display: block;
  width: var(--skeleton-width, 100%);
  height: var(--skeleton-height, auto);
  background-color: surface.$surface-hover;
}

.text {
  height: var(--skeleton-height, 1em);
  border-radius: 4px;
  transform: scale(1, 0.7);
  transform-origin: 0 50%;
}

.rectangular {
  border-radius: 0;
}

.rounded {
  border-radius: 8px;
}

.circular {
  border-radius: 50%;
}

.pulse {
  animation: skeletonPulse 1.5s ease-in-out 0.5s infinite;
}

.wave {
  position: relative;
  overflow: hidden;

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    transform: translateX(-100%);
    background: linear-gradient(90deg, transparent, surface.$surface-raised, transparent);
    animation: skeletonWave 1.6s linear 0.5s infinite;
  }
}

@keyframes skeletonPulse {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.4;
  }
  100% {
    opacity: 1;
  }
}

@keyframes skeletonWave {
  100% {
    transform: translateX(100%);
  }
}

@media (prefers-reduced-motion: reduce) {
  .pulse,
  .wave::after {
    animation: none;
  }
}
